import { GraphQLClient } from "graphql-request";
import type { HighnoteEnvironment, SdkIdentity } from "@highnoteplatform/types";

import { getSdk } from "./generated/graphql";

export type {
  CreateUsPersonAccountHolderInput,
  CreateUsPersonAccountHolderMutation,
  UsPersonAccountHolder,
  AccountHolder,
  UserError,
  AccessDeniedError,
  DocumentUploadLink,
} from "./generated/graphql";

export {
  PhoneLabel,
  DocumentType,
  DocumentUploadSessionStatusCode,
} from "./generated/graphql";

const apiUrls: Record<HighnoteEnvironment, string> = {
  test: "https://api.us.test.highnote.com",
  live: "https://api.us.highnote.com",
};

export const highnoteClient = (
  token: string,
  environment: HighnoteEnvironment = "test",
  sdk?: SdkIdentity
) => {
  const client = new GraphQLClient(`${apiUrls[environment]}/graphql`);

  client.setHeader("authorization", `Bearer ${token}`);

  if (sdk?.name && sdk?.version) {
    client.setHeader("x-highnote-sdk", `${sdk.name}/${sdk.version}`);
  }

  return getSdk(client);
};
